<!--/****************************************************************************************************************
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
-->
@if (isAppBusy) {
  <div>
    <mat-progress-spinner color="primary" class="spinner" mode="indeterminate"> </mat-progress-spinner>
  </div>
}
@if (!isAppBusy) {
  <div class="content">
    <h1 mat-dialog-title>{{headerData.title}}</h1>
    @if (nodes.length != 0) {
      <div>
        <mat-card class="header tree-header">
          <mat-card-content>
            <h1 class="hierarchy-sub-title">User Mappings</h1>
            <div class="hierarchy-user-mappings">
              @for (supplier of supplierList; track supplier) {
                <mat-list >
                  <mat-list-item class="hierarchy-user-mappings-list" (click)="expandNode(supplier.id)" [ngClass]="{'item-active': supplier.active}">
                  {{supplier.name}}</mat-list-item>
                  <!-- <mat-list-item role="listitem">Item 2</mat-list-item>
                  <mat-list-item role="listitem">Item 3</mat-list-item> -->
                </mat-list>
              }
              <div>
                <!-- <div class="supplier-name">{{supplierName}}</div> -->
                <!-- <div class="breadcrumb">
                <div class="supplier-name">{{supplierName}}</div>
                <mat-icon *ngIf="(i < (supplierList.length-1))" class="right-arrow">chevron_right</mat-icon>
              </div> -->
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card class="tree">
        <mat-card-content>
          <h1 class="hierarchy-sub-title">Available Mappings</h1>
          <div mat-dialog-content style="height: 175px;">
            <tree-root #tree [nodes]="nodes" [options]="options" (deactivate)= "setUserHierarchy($event.node.data, false)" (activate)="setUserHierarchy($event.node.data, true)">
              <ng-template #treeNodeTemplate let-node let-index="index">
                <div>
                  {{ node.data.name }}
                </div>
              </ng-template>
            </tree-root>
          </div>
        </mat-card-content>
      </mat-card>
      <div mat-dialog-actions class="actions">
        <button mat-button (click)="closeModal()">{{ 'supplier.hierarchy.action.cancel' | translate }}</button>
        <button mat-raised-button color="primary" [disabled]="!isMapHierarchyBtn"
        (click)="mapUserToHierarchy()">{{ 'supplier.hierarchy.action.map' | translate }}</button>
        <button mat-raised-button color="primary" [disabled]="!isRemoveHierarchyBtnEnabled"
        (click)="removeMappingToUser()">{{ 'supplier.hierarchy.action.delete' | translate }}</button>
      </div>
    </div>
  } @else {
    No hierarchy data found.
  }
</div>
}

